import { AfterViewInit, Component, ElementRef, ViewChild } from "@angular/core";

@Component({
    selector: 'ui-data-header',
    templateUrl: './ui-data-header.component.html'
})
export class UIDataHeaderComponent implements AfterViewInit {
    @ViewChild('header') header: ElementRef<HTMLTableCellElement>;

    ngAfterViewInit(): void {

    }
}
